import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Router, useRouterHistory, applyRouterMiddleware } from 'react-router';
import { createHistory } from 'history';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import useScroll from 'react-router-scroll/lib/useScroll';

import routes from './routes';
import { configureStore } from './state/store';
import bowser from 'bowser';
import './members.scss';
import { navigateToWebsite } from 'utils/sagas';
import { getAuthData, hasValidToken } from 'authStore';

require('../../assets/favicons/favicon.ico');

function run(authData) {
  const browserHistory = useRouterHistory(createHistory)({
    basename: process.env.KOOTH_ROUTER_BASE
  });

  const store = configureStore(browserHistory, authData);
  const enhancedHistory = syncHistoryWithStore(browserHistory, store);

  let app = document.getElementById("app");

  if (bowser.msie) {
    app.className += "isBrowserIE";
  }

  if (bowser.msedge) {
    app.className += "isBrowserEdge";
  }

  render(
    <Provider store={store}>
      <Router history={enhancedHistory} routes={routes} render={applyRouterMiddleware(useScroll())} />
    </Provider>,
    app
  );
}

if(hasValidToken()) {
  run(getAuthData());
}
else {
  navigateToWebsite();
}



/** WEBPACK FOOTER **
 ** ./src/members/members.js
 **/